import { render, staticRenderFns } from "./index.vue?vue&type=template&id=742cefa9&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742cefa9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\G\\YT\\mes-project-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('742cefa9')) {
      api.createRecord('742cefa9', component.options)
    } else {
      api.reload('742cefa9', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=742cefa9&scoped=true&lang=pug", function () {
      api.rerender('742cefa9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wl-component-gallery/wl-jm-print/index.vue"
export default component.exports